import React from 'react';

import { Location, Contact } from '_lib/api/apiTypes.shim';
import { Card } from '_lib/components/Card/Card';

import { Locations } from '../Locations/Locations';

interface LocationsCardProps {
  companyId: string;
  providerCustomerId: string;
  locations: Location[];
  locationContactsMap: {
    [locationProviderId: string]: Contact[];
  };
  onLocationsUpdated: (locations: Location[]) => void;
  onLocationContactsUpdated: (locationProviderId: string, contacts: Contact[]) => void;
}

export const LocationsCard = (props: LocationsCardProps): React.ReactElement => {
  const {
    companyId,
    providerCustomerId,
    locations,
    locationContactsMap,
    onLocationsUpdated,
    onLocationContactsUpdated
  } = props;

  return (
    <Card variant='outlined'>
      <Locations
        companyId={companyId}
        providerCustomerId={providerCustomerId}
        locations={locations}
        locationContactsMap={locationContactsMap}
        onLocationsUpdated={onLocationsUpdated}
        onLocationContactsUpdated={onLocationContactsUpdated}
      />
    </Card>
  );
};
